import { registerContainers as origin } from '@cloudbase/container';
import { ICloudbase } from '@cloudbase/types';

export const registerContainers = origin as (app: ICloudbase) => void;

try {
  (window as any).registerContainers = registerContainers
} catch (e) {}